module.exports = __webpack_public_path__ + "img/magyarorszag_logo_color_white_text.b84e9891.png";